import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  preview: {
    firstPreview: {
      margin: 'auto',
    },
  },
}))

export default useStyles
